import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Icon } from "antd";
import Directions from "./../../../services/directions";
import withTracker from "./../../withTracker";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sortOrder: undefined,
      data: {
        graves: undefined,
      },
    };
  }

  componentDidMount() {
    if (this.props && !this.props.data.data.loading) {
      this.setState({
        loading: false,
        data: {
          ...this.props.data.data,
          graves: this.props.data.data.graves.filter(
            (grave) => grave.Cemetery === this.props.data.name
          ),
        },
        currentPos: this.props.data.currentPos,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.data &&
      this.state.data.graves &&
      this.state.sortored === undefined
    ) {
      this.setState({ sortored: "alphabet" });
      this.onFilterChange("alphabet");
    }
    if (this.props.data.name !== prevProps.data.name) {
      this.setState({
        loading: false,
        data: {
          ...this.props.data.data,
          graves: this.props.data.data.graves.filter(
            (grave) => grave.Cemetery === this.props.data.name
          ),
        },
        sortOrder: undefined,
        currentPos: this.props.data.currentPos,
      });
    }
  }

  onFilterList(e) {
    let newArr = this.props.data.data.graves.filter((grave) => {
      let fullName = `${grave.FirstName} ${grave.LastName}`;
      return (
        fullName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1 &&
        grave.Cemetery === this.props.data.name
      );
    });
    this.setState({ data: { ...this.state.data, graves: newArr } });
  }

  exPL(word) {
    let replaced = word.toLowerCase().replace(/[ąęśćółńżź]/g, (s) => {
      s.toLowerCase();
      return (
        (s === "ą"
          ? "a"
          : s === "ę"
          ? "e"
          : s === "ś"
          ? "s"
          : s === "ć"
          ? "c"
          : s === "ó"
          ? "o"
          : s === "ł"
          ? "l"
          : s === "ń"
          ? "n"
          : s === "ż"
          ? "z"
          : "zż") + "ż"
      );
    });

    return replaced;
  }

  onFilterChange(e) {
    let start = this.props.data.entry;

    if (this.props.data.currentPosInBounds) {
      start = [
        this.props.data.currentPosClosest.lng,
        this.props.data.currentPosClosest.lat,
      ];
    }

    this.setState({ sortOrder: e });

    if (this.state.data.graves && !!this.state.data.graves.length) {
      if (e === "alphabet") {
        this.state.data.graves.sort((a, b) => {
          if (this.exPL(a.FirstName) < this.exPL(b.FirstName)) return -1;
          if (this.exPL(a.FirstName) > this.exPL(b.FirstName)) return 1;
          return 0;
        });
      }

      if (e === "distance") {
        const withDistance = this.state.data.graves
          .map((grave) => {
            const distance =
              Directions.findPath(grave.geometry.closestLL, [
                start[1],
                start[0],
              ]).weight *
                1000 +
              grave.geometry.closest.distance;
            return { ...grave, distance };
          })
          .sort((a, b) => a.distance - b.distance);

        this.setState({
          data: { ...this.state.data, graves: withDistance },
        });
      }
    }
  }

  updateListSelection(letter) {
    let lettersInGraves = this.state.data.graves.map((e) => {
      return e.FirstName.split("").shift();
    });

    if (lettersInGraves.includes(letter)) {
      var list = document.getElementById("gravesUl"),
        targetLi = document.getElementById(letter);
      list.scrollTop = targetLi.offsetTop - 100;
    }
  }

  render() {
    const letters = "ABCDEFGHIJKLŁMNŃOÓPRSŚTWYZŹŻ".split(",");

    return (
      <div>
        <div className="filters">
          <span
            className={
              this.state.sortOrder === "alphabet" ? "active left" : "left"
            }
            onClick={(e) => this.onFilterChange("alphabet")}
          >
            ALFABETYCZNIE
          </span>{" "}
          <span
            className={
              this.state.sortOrder === "distance" ? "active right" : "right"
            }
            onClick={() => this.onFilterChange("distance")}
          >
            WG ODLEGŁOŚCI
          </span>
        </div>
        <main className="list">
          <div className="fixed">
            <input
              placeholder="Wpisz nazwisko..."
              onChange={(e) => this.onFilterList(e)}
            ></input>
            <Icon type="search" />
            <div className="letters">
              {letters.map((letter) => {
                return (
                  <span
                    key={letter}
                    onClick={() => this.updateListSelection(letter)}
                  >
                    {letter}
                  </span>
                );
              })}
            </div>
          </div>
          <ul className="ul-graves" id="gravesUl">
            {!this.state.loading &&
              this.state.data.graves
                .filter((e) => e.Cemetery === this.props.match.params.cemetery)
                .map((e) => {
                  return (
                    <li id={e.FirstName.split("").shift()} key={e.ID}>
                      <Link
                        to={`/${
                          this.props.data.name
                        }/grave/${this.props.data.data.graves.indexOf(e)}`}
                      >
                        {e.FirstName} {e.LastName}
                        {e.distance &&
                          this.state.sortOrder === "distance" &&
                          ` ${e.distance.toFixed(0)}m`}
                      </Link>
                    </li>
                  );
                })}
          </ul>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(List)));



// WEBPACK FOOTER //
// ./src/js/containers/list/index.js